import React from "react";
import Button from "components/button";
import Featured from "./Featured";
import { BUTTONSTORE_ICONS } from "variables/constants";
import { displayIcon } from "variables/icons";

const CategoryFilter = ({ categories = [], value, onChange, className = "", onBrowseAll }) => {

    const categoryFilters = [
		{
			category_id: "all",
			name: "All Vouchers",
		},
		...categories,
	];

    return (
        <div className={className}>
            <div className={`flex gap-2 pb-6 ${className}`}>
                {categoryFilters.map((item) => {
                    const isActive = value === item.category_id;

                    const buttonClass = isActive
                    ? "access-button btn-category"
                    : "access-button btn-filter border !h-9 !px-4 py-2 !text-sm ";

                    return (
                        <Button
                            key={item.category_id}
                            onClick={() => onChange(item.category_id)}
                            variant={isActive ? "default" : "outline"}
                            className={buttonClass}
                        >
                            {displayIcon(BUTTONSTORE_ICONS[item.name],"w-4 h-4 mr-2")}
                            {item.name}
                        </Button>
                    );
                })}
            </div>
            {value === "all" && <Featured onBrowseAll={onBrowseAll}/>}
        </div>
    );
};

export default CategoryFilter;
